import { render, staticRenderFns } from "./CasePageHeader.vue?vue&type=template&id=5d49914b&scoped=true"
import script from "./CasePageHeader.vue?vue&type=script&lang=js"
export * from "./CasePageHeader.vue?vue&type=script&lang=js"
import style0 from "./CasePageHeader.vue?vue&type=style&index=0&id=5d49914b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d49914b",
  null
  
)

export default component.exports